function set(name, value, days = 365, domain = '') {

    if (domain != '') {
        domain = ';domain =' + domain;
    };

    let expires = "",
        date = new Date();

    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = '; expires=' + date.toGMTString();

    document.cookie = name + '=' + value + expires + '; path=/' + domain;
}

function get(name) {
    const nameEq = name + '=',
        ca = document.cookie.split(';');

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEq) === 0) {
            return c.substring(nameEq.length, c.length);
        }
    }

    return null;
}

function clear(name) {
    set(name, '', -1);
}

export { set, get, clear };